require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cloud-20191001-19.json") })
        }
      }, "path---cloud-20191001-19");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cloud-20191001-19!./.cache/json/cloud-20191001-19.json
// module id = 1479
// module chunks = 231608221292675